// bookingActions.js

export const updateBookingPrice = (totalCost, costPerPerson,transferType,book, short_description) => {
    return {
      type: 'UPDATE_BOOKING_PRICE',
      payload: {
        totalCost,
        costPerPerson,
        transferType,
        book,
        short_description,
      },
    };
};
  